import {
  BackupStatus,
  ConditionOperatorEnum,
  type Condition,
} from '@repo/api-gw-sdk';

import { BACKUP_STATUS_PROPERTY } from '../queryBuilder/propertyNames';

export const NON_POSTURE_BACKUP_STATUSES: BackupStatus[] = [
  BackupStatus.ExcludedFromBackup,
  BackupStatus.Disconnected,
  BackupStatus.Unsupported,
  BackupStatus.LimitExceeded,
];

/**
 * The hidden statuses the inventory's filter bar carries as an ordinary filter.
 * Unsupported is missing on purpose: the inventory settings toggle owns it, so it
 * is excluded by the view rather than offered as a status to filter by.
 */
export const FILTER_BAR_EXCLUDED_BACKUP_STATUSES: BackupStatus[] =
  NON_POSTURE_BACKUP_STATUSES.filter(
    (status) => status !== BackupStatus.Unsupported
  );

export const createBackupStatusNotInCondition = (
  values: string[]
): Condition => ({
  property: BACKUP_STATUS_PROPERTY,
  operator: ConditionOperatorEnum.NotIn,
  value: values,
});

export const createBackupStatusInCondition = (values: string[]): Condition => ({
  property: BACKUP_STATUS_PROPERTY,
  operator: ConditionOperatorEnum.In,
  value: values,
});
